module.exports = __webpack_public_path__ + "img/logo.1bbbb554.png";